import React from 'react';
import CustomButton from './CustomButton';
import Image from 'next/image';

/**
 * SectionHero Component
 * Hero section with main call-to-action
 */
const SectionHero: React.FC = () => {
  const heroImageUrl = "/image/hero-new.webp";
  const pattern ="/image/pattern.webp"

  return (
    <div
      className="relative w-full h-full overflow-hidden bg-linear-to-r from-[#EEDA44] to-[#FFE83D] "
    >

     <div className="absolute inset-0 opacity-2">
        <Image
          src={pattern}
          alt="background pattern"
          fill
          className="object-cover"
          priority
          quality={30}
          sizes="100vw"
        />
      </div>

      {/* Hero Image - Behind Content */}
      <div className='lg:block md:block hidden absolute lg:right-[-0%] md:right-[-40%] right-0  top-0 lg:w-[40%] md:w-[90%] w-full h-full z-1'>
        <Image
          fill
          alt='hero'
          className='object-cover object-[50%_50%]'
          src={heroImageUrl}
          priority
          sizes="(min-width: 1024px) 40vw, (min-width: 768px) 50vw, 100vw"
          quality={75}
        />
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex lg:flex-row md:flex-row flex-col items-center max-w-6xl mx-auto">
        <div className="w-full flex md:justify-start justify-center lg:py-16 pb-0 md:py-12 py-6 lg:px-0 md:px-12 px-6 ">
          <div className="lg:w-[900px] md:w-[400px] w-full flex flex-col gap-8">
            <div className="flex flex-col gap-4">
              <div className="flex flex-col gap-4 md:pb-0 pb-[32px]">
                <p className="font-family-open-sans font-bold lg:text-[18px] md:text-[14px] text-[14px] md:text-left text-center text-sm tracking-[0.18px] text-black m-0">
                  Operator Resmi Wisata Arung Jeram Sungai Pekalen
                </p>

                <h1 className="banner-text font-bold lg:text-[64px] md:text-[40px] text-[40px] md:text-left text-center lg:leading-16 md:leading-11 leading-10 tracking-[-0.64px] text-[#222222] m-0 ">
                 Mau Passive Income Tanpa Modal? Yuk Jadi Mitra & Agen Pekalen Rafting Sekarang
                </h1>

                <p className="font-family-open-sans font-normal lg:w-[750px] md:w-[390px] w-full lg:text-[16px] md:text-[14px] text-[14px] md:text-left text-center lg:leading-8 md:leading-8 leading-5 tracking-[0.18px] text-black m-0">
                  Raih penghasilan hingga jutaan rupiah setiap bulan dengan menjadi partner resmi
                  kami. Komisi menarik, training gratis, dan support penuh menanti Anda!
                </p>
              </div>

              {/* Action Buttons */}
              <div className="flex gap-3 flex-wrap md:justify-start justify-center">
                <CustomButton
                  text='Gabung Sekarang'
                  onClick={() => {
                    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                />
              </div>
            </div>
          </div>
        </div>
           <div className='lg:hidden md:hidden block w-full md:h-full  h-[400px] overflow-hidden relative'>
                <Image
                  fill
                  alt='hero'
                  className='object-cover object-[50%_15%]'
                  src={heroImageUrl}
                  priority
                  sizes="100vw"
                  quality={75}
                  />
              </div>

      </div>
    </div>
  );
};

export default SectionHero;
